import { useEffect, useRef, useState } from "react";

export default function Timer({ isRunning, startTime }) {
  const [seconds, setSeconds] = useState(0);
  const intervalRef = useRef(null);

  // Calculate initial time (important for refresh / backend time)
  useEffect(() => {
    if (startTime) {
      const diff =
        Math.floor((Date.now() - new Date(startTime).getTime()) / 1000) || 0;
      setSeconds(diff);
    }
  }, [startTime]);

  useEffect(() => {
    if (isRunning) {
      intervalRef.current = setInterval(() => {
        setSeconds((prev) => prev + 1);
      }, 1000);
    } else {
      clearInterval(intervalRef.current);
    }

    return () => clearInterval(intervalRef.current);
  }, [isRunning]);

  const formatTime = () => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    return `${hrs.toString().padStart(2, "0")}:${mins
      .toString()
      .padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
  };

  if (!isRunning) return null;

  return (
    <div className="mt-2">
      <span className="btn btn-success fs-6">
        ⏱ Checked in: {formatTime()}
      </span>
    </div>
  );
}
